<template>
<div>
    <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
        <v-container text-xs-center>
           <HistoryTab :currentTab="currentTab"/>

            <!--Date pickers-->
            <v-container grid-list-md>

                <v-layout row wrap>
                    <v-flex xs6 sm6 md6>
                        <v-menu :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="fromDate" :label="$t( 'history.date_from' )" prepend-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="fromDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs6 lg6>
                        <v-menu :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="toDate" :label="$t( 'history.date_to' )" prepend-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="toDate"></v-date-picker>
                        </v-menu>

                    </v-flex>
                </v-layout>

                <v-layout row>
                    <v-flex xs6 sm6 md6>
                        <v-btn block color="success" @click.prevent="getTicket">
                            <v-icon size="12px">fas fa-search</v-icon>
                            &nbsp;
                            {{ $t( 'shared.search' )  }}
                        </v-btn>
                    </v-flex>

                    <v-flex xs6 sm6 md6>
                        <v-btn block color="error" @click.prevent="resetDate">
                            <v-icon size="12px">fas fa-undo</v-icon>
                            &nbsp;
                            {{ $t( 'shared.reset' )  }}
                        </v-btn>
                    </v-flex>
                </v-layout>

                 <TicketDialog :dialog="showDialog" :detail="dialogDetail" @close-dialog="closeDialog" />

            </v-container>

            <v-divider></v-divider>

            <!--Table-->
            <v-data-table
                v-if="rows != null"
                :headers="headers"
                :items="rows"
                class="elevation-1 mt-2"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="rowsPerPageItems"
                :rows-per-page-text="rowsPerPageItemsText"
                :loading="isLoading">
                <v-progress-linear v-slot:progress color="blue" :indeterminate="true"></v-progress-linear>

                <template v-slot:items="props">
                    <tr @click="showTicketDetail([props.item])">
                        <td class="text-xs-center" v-html="formatDate(props.item.created_at)"></td>
                        <td class="text-xs-right">{{ props.item.amount }}</td>
                        <td class="text-xs-center" v-html="getStatusText(props.item.status)"></td>
                        <td class="text-xs-center">
                            <v-btn small outline>
                                <span>{{ $t( 'history.withdraw' )  }}</span>
                            </v-btn>
                        </td>
                    </tr>
                </template>

            </v-data-table>
        </v-container>

    </v-flex>
</div>
</template>

<script>
import Api from "@/api";
import moment from "moment";
import TicketDialog from "@/components/Reusable/TicketDialog.vue";
import HistoryTab from "@/components/History/HistoryTab.vue";

export default {
    name: "WithdrawTicket",
    data() {
        return {
            tickets: [

            ],
            pagination: {
                rowsPerPage: 10,
                totalItems: 0,
                page: 1
            },
            showDialog: false,
            dialogDetail: {},
            rowsPerPageItems: [10],
            rowsPerPageItemsText: "10",
            isLoading: false,
            fromDate: '',
            toDate: '',
            currentTab: 'withdraw',
            //sample table header and data
            headers: [{
                    text: this.$t( 'history.date' ),
                    align: 'center',
                    sortable: false,
                    value: 'created_at'
                },
                {
                    text: this.$t( 'history.amount' ),
                    align: 'center',
                    sortable: false,
                    value: 'amount'
                },
                {
                    text: this.$t( 'history.status' ),
                    align: 'center',
                    sortable: false,
                    value: 'status'
                },
                {
                    text: this.$t( 'history.detail' ),
                    align: 'center',
                    sortable: false,
                    value: 'detail'
                }
            ],
            rows: [
            ],
        }
    },
    components: {
        TicketDialog,
        HistoryTab
    },
    methods: {
        getTicket: async function(){
            this.isLoading = true;
            // prepare api data
            let params = {
                access_token: this.$store.getters.user_token,
                size: this.pagination.rowsPerPage,
                type: 'withdraw',
                page: this.pagination.page
            };

            if (this.toDate) {
                params.dateTo = this.toDate + ' 23:59:59';
                // delete params.page;
            }

            if (this.fromDate) {
                params.dateFrom = this.fromDate + ' 00:00:00';
                // delete params.page;
            }

            let res = await Api.getTicketHistory(params);

            if (res && 'success' in res && res.success === true) {
                this.rows = res.data.data;
                this.pagination.rowsPerPage = res.data.per_page;
                this.pagination.totalItems = res.data.total;
            } else {
                if(res.message == "token invalid") {
                    this.$store.dispatch('logout', res.data);
                    this.$router.push({name: 'login'})
                }
            }
            this.isLoading = false;
        },
        resetDate: function() {
            this.toDate = "";
            this.fromDate = "";
        },
        formatDate: function(dateString) {
            let date = moment(dateString).format('DD/MM/YY<br/>hh:mmA');
            return date;
        },
        getStatusText: function(status) {
            let text = status;
            if (status == 'Approved') {
                status = this.$t( 'history.approved' );
                text = '<strong class="text-success">' + status + '</strong>';
            } else if (status == 'Reject') {
                status = this.$t( 'history.reject' );
                text = '<strong class="text-danger">' + status + '</strong>';
            } else if (status == 'New') {
                text = this.$t( 'history.new' );
            } else if (status == 'Verified') {
                text = this.$t( 'history.verified' );
            } else if (status == 'Processing') {
                text = this.$t( 'history.processing' );
            }
            return text;
        },
        showTicketDetail: function(obj) {
            this.showDialog = true;
            this.dialogDetail = obj;
        },
        closeDialog: function() {
            this.showDialog = false;
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.getTicket()
            },
            deep: true
        }
    },
    mounted: async function() {
        await this.getTicket();
    }
}
</script>
